import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  Modal,
  Select,
  DatePicker,
  DateRangePicker,
  format_date,
  params,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  can,
} from "../../components/CustomComponent.js";
import { withRouter } from "../../components/withRouter.js";
import { getProfile } from "../../utils/localStorage.js";
import { initials, avatarTone, fmtPhone, isPartnerUser } from "../../components/people_option.js";
import { DEALS, statusMeta as assetStatusMeta } from "../../components/asset_option.js";
import {
  LEAD_STATUSES,
  PIPELINE,
  LEAD_SOURCES,
  LEAD_GRADES,
  statusMeta,
  sourceMeta,
  gradeMeta,
  isClosedStatus,
} from "../../components/customer_option.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/crm.css";
import "../../assets/css/marketing.css"; // ตารางเลือกทรัพย์ใช้หน้าตาเดียวกับคิวงานโพสต์ (.mk-table)

/* ============================================================================
 * ลูกค้า  (/ad/customers)
 * รายชื่อผู้สนใจเช่า/ซื้อทรัพย์ — หน้านี้ใช้ติดตามผลเป็นหลัก
 * ลูกค้าเข้าระบบได้ทั้งจากช่องทางต้นทาง (เว็บไซต์ / LINE / เพจ) และจากปุ่ม
 * "เพิ่มลูกค้า" ของแอดมินเอง (เคสโทรเข้า / walk-in / คู่ค้าแนะนำ)
 *
 * สิ่งที่ทำได้ในหน้านี้ : เพิ่มลูกค้า, กรอง-ค้นหา, ดูรายละเอียด, อัปเดตสถานะการติดตาม,
 * มอบหมายผู้ดูแล, บันทึกกิจกรรม/โน้ต, ส่งต่อไปสร้างนัดชมทรัพย์
 *
 * ข้อมูลจริงทั้งหน้า (ไม่มี mock แล้ว) :
 *   GET    admin/customers                 รายการ + ตัวกรอง (page 0 = ทั้งหมด สำหรับบอร์ด)
 *   GET    admin/customers/summary         การ์ดสรุป + ยอดของแต่ละขั้นใน pipeline
 *   GET    admin/customers/:uid            รายละเอียด + ไทม์ไลน์ + ทรัพย์ที่สนใจ
 *   GET    admin/customers/duplicate       เช็กเบอร์ซ้ำก่อนบันทึก
 *   POST   admin/customers                 เพิ่มลูกค้า
 *   PUT    admin/customers/:uid            แก้ไข / เปลี่ยนสถานะ / มอบหมายผู้ดูแล
 *   POST   admin/customers/:uid/activities บันทึกกิจกรรม-โน้ต
 * ตัวเลือกที่ต้องใช้ในฟอร์มดึงจาก master จริงเช่นกัน :
 *   GET admin/users (ผู้ดูแล) · GET admin/asset-categories (ประเภททรัพย์) · GET admin/assets (ทรัพย์ที่สนใจ)
 * ========================================================================== */

const PAGE_SIZE = 10;

/* ค่าเริ่มต้นของฟอร์มเพิ่มลูกค้า — คีย์ทั้งหมดวางให้ตรงกับ payload ที่ส่งให้ API */
const EMPTY_FORM = {
  name: "",
  nickname: "",
  phone: "",
  email: "",
  source: "website",
  grade: "warm",

  deal: "rent",
  asset_category_uid: "",
  zone: "",
  budget_min: "",
  budget_max: "",
  move_in_at: null,
  note: "",

  asset_uids: [],       // uid ของทรัพย์ที่ลูกค้าสนใจ (เลือกได้หลายรายการ)

  status: "new",
  admin_uid: "",
  next_follow_at: null,
  first_note: "",       // โน้ตแรกของแอดมิน — ลงเป็นกิจกรรมแรกในไทม์ไลน์
};

const EMPTY_FILTER = {
  keyword: "",
  status: "",
  deals: [],                                  // ติ๊กได้หลายอัน / ไม่ติ๊กเลย = ไม่กรอง
  category: "",                               // uid ของประเภททรัพย์ที่ลูกค้าต้องการ
  source: "",
  grade: "",
  admin: "",
  due: "",                                    // "" | overdue | today | week
  created: { start_date: null, end_date: null },
};

const SORTS = [
  { value: "due_asc", label: "sort_follow_due" },
  { value: "created_desc", label: "sort_newest_lead" },
  { value: "created_asc", label: "sort_oldest_lead" },
  { value: "grade_desc", label: "sort_grade" },
  { value: "budget_desc", label: "sort_budget_desc" },
  { value: "name_asc", label: "sort_name" },
];

const DUE_OPTIONS = [
  { value: "overdue", label: "due_overdue" },
  { value: "today", label: "due_today" },
  { value: "week", label: "due_this_week" },
];

const EMPTY_SUMMARY = {
  total: 0,
  status: {},
  new_lead: 0,
  following: 0,
  appointment: 0,
  won: 0,
  win_rate: 0,
  overdue: 0,
  today: 0,
};

/* ---------------------------------------------------------------- ตัวช่วย */
const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");
const num = (value) => Number(value || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });
const dateText = (value) => (value ? format_date(value, "dd mmm yyyy", locale()) : "-");

/* ช่องที่ลูกค้าไม่ได้กรอก (อีเมล / โซนที่อยากได้ / โน้ต) ส่งมาเป็น "" หรือ null
   ปล่อยว่างไว้ในตารางจะแยกไม่ออกว่า "ไม่มีข้อมูล" หรือ "โหลดไม่ขึ้น" — เติม - ไว้แทน */
const dash = (value) => {
  const text = value === 0 ? "0" : String(value ?? "").trim();
  return text || "-";
};
const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
const TODAY = startOfDay(new Date());
const dayDiff = (date) => Math.round((startOfDay(new Date(date)) - TODAY) / 86400000);

/* ค่าที่ส่งให้ API เป็น YYYY-MM-DD เสมอ (คอลัมน์ฝั่ง backend เป็น DATEONLY)
   DatePicker คืนค่ามาเป็นสตริงรูปแบบนี้อยู่แล้ว ส่วนค่าที่โหลดกลับมาเป็น Date ก็แปลงให้ */
const toISODate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};

/* งบประมาณแบบย่อ : 12,000 / 8.9 ล้าน — ตัวเลขยาว ๆ อ่านยากในตาราง */
const shortMoney = (value) => {
  const n = Number(value || 0);
  if (n >= 1000000) return `${Number((n / 1000000).toFixed(2))} ${t("unit_million")}`;
  return num(n);
};

/* งบประมาณกรอกมาไม่ครบได้ (รู้แต่เพดาน / ยังไม่ระบุเลย) — โชว์ "0 - 0" จะอ่านเป็นงบศูนย์บาท */
const budgetText = (item) => {
  const min = Number(item.budget_min) || 0;
  const max = Number(item.budget_max) || 0;
  if (!min && !max) return "-";
  if (!min) return `${t("budget_upto")} ${shortMoney(max)}`;
  if (!max) return `${t("budget_from")} ${shortMoney(min)}`;
  return `${shortMoney(min)} - ${shortMoney(max)}`;
};

/* ไม่มีงบก็ไม่ต้องมีหน่วย "บาท" ต่อท้าย (จะกลายเป็น "- บาท") */
const hasBudget = (item) => Number(item.budget_min) > 0 || Number(item.budget_max) > 0;

/* ชื่อประเภททรัพย์จาก master ที่ API ส่งมา (asset_category) */
const categoryName = (category) => (category ? (isTh() ? category.name_th : category.name_en || category.name_th) : "-");

/* ทรัพย์จาก GET admin/assets — ย่อให้เหลือเท่าที่ตารางเลือกทรัพย์ต้องใช้
   (รูปแบบเดียวกับ interested ที่ API ของลูกค้าส่งกลับมา จะได้ใช้โค้ดวาดชุดเดียวกัน) */
const normalizeAsset = (item) => ({
  uid: item.uid,
  code: item.code || "",
  title: item.headline || item.title || item.project || "",
  zone: item.district || "",
  type: item.type || "",
  rent: Number(item.rent) || 0,
  price: Number(item.price) || 0,
  status: item.status || "available",
  image: item.image || "",
  asset_category: item.asset_category || null,
});

/* สี/ไอคอนของแต่ละชนิดเหตุการณ์ในไทม์ไลน์
   ชนิดที่ไม่อยู่ในนี้ (won / lost / status_changed) ใช้สีของสถานะปลายทางแทน
   เพื่อให้จุดบนไทม์ไลน์กับป้ายสถานะด้านบนเป็นสีเดียวกัน */
const TIMELINE_TONE = {
  created: { color: "#0369a1", icon: "" },
  note: { color: "#4d7c0f", icon: "" },
  assigned: { color: "#0369a1", icon: "" },
  called: { color: "#0e7490", icon: "" },
  requirement: { color: "#6d28d9", icon: "" },
  appointment: { color: "#b45309", icon: "" },
  offer: { color: "#c2410c", icon: "" },
};

/* คำบรรยายใต้หัวข้อของแต่ละเหตุการณ์
   - โน้ต/กิจกรรมที่ทีมพิมพ์เอง : แสดงข้อความตรง ๆ
   - เปลี่ยนสถานะ : ไม่มีข้อความ จึงเล่าจาก meta (จากสถานะไหน → ไปสถานะไหน)
   - ลูกค้าเข้ามาในระบบ : เล่าว่ามาจากช่องทางไหน */
const activityDetail = (entry) => {
  /* คำขอที่ลูกค้ากดส่งมาเองจากหน้าเว็บ (ปุ่ม "ลงทะเบียนสนใจทรัพย์")
     วัน/ช่วงเวลาที่สะดวกอยู่ใน meta ต้องเล่าให้เห็นในไทม์ไลน์ ไม่งั้นแอดมินเห็นแค่หัวข้อ
     "นัดชมทรัพย์" โดยไม่รู้ว่าลูกค้าขอวันไหน */
  if (entry.meta?.channel === "website") {
    const slot = entry.meta.visit_time ? ` · ${t(`visit_slot_${entry.meta.visit_time}`)}` : "";
    return [
      entry.meta.visit_date && `${t("visit_requested_on")} ${dateText(entry.meta.visit_date)}${slot}`,
      // ชื่อที่กรอกมาไม่ตรงกับชื่อในระบบ — โชว์ไว้ให้รู้ว่าคราวนี้ใครเป็นคนส่งเข้ามา
      entry.meta.contact_name && `${t("customer_name")} : ${entry.meta.contact_name}`,
      entry.detail,
    ]
      .filter(Boolean)
      .join(" · ");
  }

  if (entry.detail) return entry.detail;

  if (entry.type === "created") return t(sourceMeta(entry.meta?.source).label);

  const to = entry.meta?.to_status;
  if (!to) return "";

  const from = entry.meta?.from_status;
  return from ? `${t(statusMeta(from).label)} → ${t(statusMeta(to).label)}` : t(statusMeta(to).label);
};

/* บัญชีพาร์ตเนอร์ที่ล็อกอินอยู่ — พาร์ตเนอร์เป็นนายหน้าภายนอกที่ดูแลลูกค้าที่ตัวเอง
   หามาเองเท่านั้น ช่อง "ผู้ดูแล / แอดมิน" จึงล็อกไว้ที่ชื่อตัวเอง เลือกโยนงานให้
   ทีมงานคนอื่นไม่ได้ คืน null เมื่อเป็นผู้ใช้ภายใน (ยังเลือกได้ตามปกติ)
   นี่เป็นแค่ UX เหมือน can() — ด่านจริงต้องอยู่ฝั่ง backend */
const partnerSelf = () => {
  const me = getProfile();
  return isPartnerUser(me) ? me : null;
};

/* ข้อความวันติดตามถัดไป + โทนสี (เลยกำหนด / วันนี้ / ปกติ) */
const dueInfo = (date) => {
  if (!date) return null;
  const diff = dayDiff(date);
  if (diff < 0) return { tone: "is-late", text: `${t("due_overdue")} ${Math.abs(diff)} ${t("unit_days")}` };
  if (diff === 0) return { tone: "is-today", text: t("due_today") };
  if (diff === 1) return { tone: "", text: t("due_tomorrow") };
  return { tone: "", text: `${t("due_in")} ${diff} ${t("unit_days")}` };
};

class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: { ...EMPTY_FILTER },   // ตัวกรองในฟอร์ม (ยังไม่กดค้นหา)
      applied: { ...EMPTY_FILTER },  // ตัวกรองที่ใช้กับผลลัพธ์ปัจจุบัน
      sort: "due_asc",
      view: "table",                 // table | board
      page: 1,
      data: [],                      // ลูกค้าของหน้าปัจจุบัน
      count: 0,
      summary: { ...EMPTY_SUMMARY }, // การ์ดสรุป + ยอดของแต่ละขั้น (มาจาก API)
      board: [],                     // ผลลัพธ์ทั้งหมดของตัวกรอง — ใช้เฉพาะมุมมองบอร์ด

      admins: [],                    // ผู้ดูแล/แอดมิน (GET admin/users)
      categories: [],                // ประเภททรัพย์ (GET admin/asset-categories)
      assets: [],                    // ทรัพย์ที่เลือกได้ในฟอร์ม (GET admin/assets)

      modal_view: false,
      view_item: null,               // ลูกค้าที่กำลังเปิดดู (พร้อมไทม์ไลน์)
      note_text: "",

      menu_open: "",                 // uid ของแถวที่เปิดเมนู "..."

      modal_form: false,             // ฟอร์มเพิ่ม/แก้ไขลูกค้า
      edit_uid: "",                  // ว่าง = โหมดเพิ่มลูกค้าใหม่
      form: { ...EMPTY_FORM },
      property_keyword: "",          // คำค้นในกล่องเลือกทรัพย์ที่สนใจ
    };
  }

  componentDidMount() {
    loading(false);
    this.GetMaster();
    this.Get(1);

    // มาจากหน้านัดหมาย (?uid=...) — เปิดกล่องรายละเอียดของลูกค้ารายนั้นให้ทันที
    const uid = params("uid");
    if (uid) this.OpenView({ uid });
  }

  /* ------------------------------------------------- ตัวเลือกจากข้อมูลจริง */
  /* ผู้ดูแล / ประเภททรัพย์ / ทรัพย์ที่เลือกได้ — ดึงทีเดียวตอนเข้าหน้า
     page: 0 = เอาทั้งหมดไม่แบ่งหน้า (เป็นรายการตัวเลือก ไม่ใช่ตาราง) */
  GetMaster = async () => {
    const [users, categories, assets] = await Promise.all([
      GET("admin/users", { page: 0, is_active: true }),
      GET("admin/asset-categories", { page: 0, is_active: true }),
      GET("admin/assets", { page: 0 }),
    ]);

    this.setState({
      admins: users?.status ? users.data || [] : [],
      categories: categories?.status ? categories.data || [] : [],
      assets: assets?.status ? (assets.data || []).map(normalizeAsset).filter((e) => e.uid) : [],
    });
  };

  adminOptions = () => this.state.admins.map((a) => ({ value: a.uid, label: a.full_name }));

  /* ชื่อผู้ดูแลจาก uid — ใช้กับช่องที่แสดงเป็นข้อความแทน dropdown (พาร์ตเนอร์)
     ยังโหลดรายชื่อไม่เสร็จ/ไม่อยู่ในรายการ คืนค่าว่างให้ผู้เรียกหาทางลงเอง */
  adminName = (uid) => this.state.admins.find((a) => a.uid === uid)?.full_name || "";

  categoryOptions = () => this.state.categories.map((c) => ({ value: c.uid, label: categoryName(c) }));

  /* --------------------------------------------------------- ดึงรายชื่อลูกค้า */
  /**
   * แปลงตัวกรองในฟอร์มเป็น query ของ API — คีย์ตรงกับที่ customer.service อ่าน
   *
   * ต้องตัดคีย์ที่ไม่มีค่าออกก่อนส่ง เพราะ buildUrl ของ services/api.js ต่อ "ทุกคีย์"
   * ที่ส่งเข้าไปเป็น query string ค่า null จึงกลายเป็นข้อความ "null" แล้ววิ่งไปถึง
   * ตัวกรองวันที่ฝั่ง backend จนกลายเป็นวันที่ใช้ไม่ได้ (เคยทำให้ list พังทั้งหน้า)
   */
  query = (page, filter, sort, extra = {}) => {
    const params = {
      page,
      page_size: PAGE_SIZE,
      sort,
      data_search: filter.keyword,
      status: filter.status,
      deals: (filter.deals || []).join(","),
      asset_category_uid: filter.category,
      source: filter.source,
      grade: filter.grade,
      admin_uid: filter.admin,
      due: filter.due,
      created_start: toISODate(filter.created?.start_date),
      created_end: toISODate(filter.created?.end_date),
      ...extra,
    };

    return Object.fromEntries(
      Object.entries(params).filter(([, value]) => value !== "" && value !== null && value !== undefined)
    );
  };

  Get = async (page = 1, filter = this.state.filter, sort = this.state.sort) => {
    loading(true);
    // การ์ดสรุปใช้ตัวกรองชุดเดียวกับตาราง (ยกเว้นสถานะ ซึ่ง backend ตัดออกให้เอง)
    const [result, summary] = await Promise.all([
      GET("admin/customers", this.query(page, filter, sort)),
      GET("admin/customers/summary", this.query(0, filter, sort)),
    ]);
    loading(false);

    if (!result?.status) return;

    const rows = result.data || [];

    // ลบรายการสุดท้ายของหน้าแล้วหน้านั้นว่าง — ถอยไปหน้าก่อนหน้าให้อัตโนมัติ
    if (!rows.length && page > 1) return this.Get(page - 1, filter, sort);

    this.setState(
      {
        data: rows,
        count: result.pagination?.count || 0,
        page,
        applied: { ...filter },
        sort,
        summary: summary?.status ? { ...EMPTY_SUMMARY, ...summary.data } : this.state.summary,
      },
      // บอร์ดต้องเห็นทุกคอลัมน์ครบ จึงดึงผลลัพธ์ทั้งชุดแยกอีกรอบ (ไม่แบ่งหน้า)
      () => this.state.view === "board" && this.GetBoard(filter, sort)
    );
  };

  GetBoard = async (filter = this.state.applied, sort = this.state.sort) => {
    const result = await GET("admin/customers", this.query(0, filter, sort, { page_size: 0 }));
    if (result?.status) this.setState({ board: result.data || [] });
  };

  switchView = (view) => {
    this.setState({ view }, () => view === "board" && this.GetBoard());
  };

  /* -------------------------------------------------------------- ตัวกรอง */
  setFilter = (patch) => this.setState((prev) => ({ filter: { ...prev.filter, ...patch } }));

  clearFilters = () => this.setState({ filter: { ...EMPTY_FILTER } }, () => this.Get(1, { ...EMPTY_FILTER }));

  // คลิกขั้นตอนบนแถบ pipeline = สลับกรองเฉพาะสถานะนั้น
  toggleStage = (value) => {
    const status = this.state.applied.status === value ? "" : value;
    const filter = { ...this.state.filter, status };
    this.setState({ filter }, () => this.Get(1, filter));
  };

  /* ==================================================== ฟอร์มเพิ่มลูกค้าใหม่ */
  OpenCreate = () =>
    this.setState({
      modal_form: true,
      modal_view: false,
      menu_open: "",
      edit_uid: "",
      property_keyword: "",
      // พาร์ตเนอร์ตั้งผู้ดูแลเป็นตัวเองมาให้เลย (ช่องนี้ถูกล็อกไว้ ไม่งั้นบันทึกไม่ผ่าน)
      form: { ...EMPTY_FORM, admin_uid: partnerSelf()?.uid || EMPTY_FORM.admin_uid },
    });

  /* เปิดฟอร์มพร้อมข้อมูลเดิม — แถวในตารางมีครบทุกฟิลด์ที่ฟอร์มต้องใช้แล้ว
     (รวม asset_uids ของทรัพย์ที่สนใจ) จึงไม่ต้องยิงขอรายละเอียดซ้ำ */
  OpenEdit = (item) =>
    this.setState({
      modal_form: true,
      modal_view: false,
      menu_open: "",
      edit_uid: item.uid,
      property_keyword: "",
      form: {
        name: item.name || "",
        nickname: item.nickname || "",
        phone: item.phone || "",
        email: item.email || "",
        source: item.source || "website",
        grade: item.grade || "warm",

        deal: item.deal || "rent",
        asset_category_uid: item.asset_category_uid || "",
        zone: item.zone || "",
        // ช่องตัวเลขเป็น controlled input จึงต้องเป็นสตริง ("" = ยังไม่ได้กรอก)
        budget_min: item.budget_min ?? "",
        budget_max: item.budget_max ?? "",
        move_in_at: item.move_in_at ? new Date(item.move_in_at) : null,
        note: item.note || "",

        asset_uids: [...(item.asset_uids || [])],

        status: item.status || "new",
        // ลูกค้าเก่าที่ยังไม่มีผู้ดูแล : พาร์ตเนอร์ได้ชื่อตัวเองเติมให้ (ช่องถูกล็อก)
        admin_uid: item.admin_uid || partnerSelf()?.uid || "",
        next_follow_at: item.next_follow_at ? new Date(item.next_follow_at) : null,
        // โน้ตแรกมีเฉพาะตอนสร้าง — แก้ไขแล้วใช้กล่อง "บันทึกกิจกรรม" ในหน้ารายละเอียดแทน
        first_note: "",
      },
    });

  /* สั่งงานจากเมนู "..." — ปิดเมนูก่อนเสมอ ไม่งั้นเมนูจะค้างทับกล่องยืนยันที่เด้งขึ้นมา */
  RowAction = (item, action) => this.setState({ menu_open: "" }, () => action(item));

  CloseCreate = () => this.setState({ modal_form: false });

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  toggleInterested = (uid) =>
    this.setState((prev) => ({
      form: {
        ...prev.form,
        asset_uids: prev.form.asset_uids.includes(uid)
          ? prev.form.asset_uids.filter((e) => e !== uid)
          : [...prev.form.asset_uids, uid],
      },
    }));

  /**
   * ทรัพย์ที่ให้เลือกในฟอร์ม เรียงเป็น 3 ชั้น
   *   1) ที่เลือกไว้แล้ว — อยู่บนสุดเสมอ เรียงตามลำดับที่กดเลือก (ลำดับเดียวกับที่ส่งให้ API)
   *      คลังทรัพย์มีเป็นร้อยรายการ ถ้าไม่ดันขึ้นมาจะไม่เห็นว่าเลือกอะไรไปแล้วบ้าง
   *   2) ประเภทตรงกับที่ลูกค้าต้องการ
   *   3) ที่เหลือ
   * sort ของ JS เป็น stable อยู่แล้ว ลำดับเดิมภายในแต่ละชั้นจึงไม่สลับ
   */
  propertyChoices = () => {
    const { form, property_keyword, assets, categories } = this.state;
    const keyword = property_keyword.trim().toLowerCase();
    const list = keyword
      ? assets.filter((p) => `${p.title} ${p.code} ${p.zone}`.toLowerCase().includes(keyword))
      : assets;

    const wanted = categories.find((c) => c.uid === form.asset_category_uid)?.code || "";
    const picked = form.asset_uids;
    const rank = (item) => (picked.includes(item.uid) ? 0 : wanted && item.type === wanted ? 1 : 2);

    return [...list].sort(
      (a, b) => rank(a) - rank(b) || picked.indexOf(a.uid) - picked.indexOf(b.uid)
    );
  };

  Save = async () => {
    const { form, edit_uid } = this.state;
    const name = form.name.trim();
    const phone = form.phone.replace(/[^0-9]/g, "");
    const email = form.email.trim();
    const budget_min = Number(form.budget_min) || 0;
    const budget_max = Number(form.budget_max) || 0;

    if (!name) return alert("", "warning", t("warning"), t("verify_customer_name"));
    if (phone.length < 9) return alert("", "warning", t("warning"), t("verify_phone"));
    if (email && !/^\S+@\S+\.\S+$/.test(email)) return alert("", "warning", t("warning"), t("verify_email_format"));
    if (!form.asset_category_uid) return alert("", "warning", t("warning"), t("verify_property_type"));
    if (budget_min && budget_max && budget_min > budget_max)
      return alert("", "warning", t("warning"), t("verify_budget_range"));
    if (!form.admin_uid) return alert("", "warning", t("warning"), t("verify_agent"));

    // เบอร์ซ้ำ = น่าจะเป็นลูกค้าเดิมที่เคยติดต่อเข้ามาแล้ว เตือนก่อนแต่ยังบันทึกต่อได้
    const duplicate = await GET("admin/customers/duplicate", edit_uid ? { phone, uid: edit_uid } : { phone });
    if (duplicate?.status && duplicate.data) {
      const proceed = await alert(
        "",
        "warning",
        t("duplicate_customer"),
        `${t("duplicate_customer_desc")}\n${duplicate.data.name} · ${duplicate.data.code}`,
        t("confirm"),
        t("cancel")
      );
      if (!proceed) return;
    }

    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    const payload = {
      name,
      nickname: form.nickname.trim(),
      phone,
      email,
      source: form.source,
      grade: form.grade,
      deal: form.deal,
      asset_category_uid: form.asset_category_uid,
      zone: form.zone.trim(),
      budget_min: form.budget_min === "" ? null : budget_min,
      budget_max: form.budget_max === "" ? null : budget_max,
      move_in_at: toISODate(form.move_in_at),
      note: form.note.trim(),
      asset_uids: [...form.asset_uids],
      status: form.status,
      admin_uid: form.admin_uid,
      // ปิดงานแล้วไม่ต้องมีวันติดตามถัดไป
      next_follow_at: isClosedStatus(form.status) ? null : toISODate(form.next_follow_at),
      // โน้ตแรกส่งเฉพาะตอนสร้าง (ตอนแก้ไขใช้กล่องบันทึกกิจกรรมในหน้ารายละเอียดแทน)
      ...(edit_uid ? {} : { first_note: form.first_note.trim() }),
    };

    loading(true);
    const result = edit_uid
      ? await PUT("admin/customers/" + edit_uid, payload)
      : await POST("admin/customers", payload);
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_form: false }, () => {
      // แก้ไขแล้วอยู่หน้าเดิม / เพิ่มใหม่ให้เด้งกลับหน้าแรกเพื่อเห็นรายการที่เพิ่งบันทึก
      // ใช้ตัวกรองที่ "กดค้นหาแล้ว" เท่านั้น กันตัวกรองที่ยังพิมพ์ค้างในฟอร์มมีผลโดยไม่ตั้งใจ
      this.Get(edit_uid ? this.state.page : 1, this.state.applied);
      // เปิดกล่องรายละเอียดของคนนี้ค้างไว้อยู่ ต้องอัปเดตให้ตรงกับที่เพิ่งบันทึก
      if (edit_uid && this.state.view_item?.uid === edit_uid) this.setState({ view_item: result.data });
      alert("", "success", t("success"), edit_uid ? t("save_done") : t("add_customer_done"));
    });
  };

  /* ------------------------------------------------------------- ลบลูกค้า */
  /* ลบแบบ soft delete ฝั่ง API — ประวัติการติดตามและทรัพย์ที่สนใจถูกเก็บไว้ใน
     ฐานข้อมูล แต่จะไม่ขึ้นในหน้านี้อีก จึงต้องยืนยันก่อนเสมอ */
  Delete = async (item) => {
    this.setState({ menu_open: "" });

    const proceed = await alert(
      "",
      "warning",
      t("delete_item"),
      `${t("delete_desc")}\n${item.name} · ${item.code}`,
      t("confirm"),
      t("cancel")
    );
    if (!proceed) return;

    loading(true);
    const result = await DELETE("admin/customers/" + item.uid, null);
    loading(false);

    if (!result?.status) return;

    // ลบคนที่เปิดกล่องรายละเอียดค้างไว้อยู่ ต้องปิดกล่องด้วย ไม่งั้นค้างข้อมูลที่ไม่มีแล้ว
    if (this.state.view_item?.uid === item.uid) this.setState({ modal_view: false, view_item: null });

    // Get จะถอยกลับหน้าก่อนหน้าให้เองถ้าลบรายการสุดท้ายของหน้าไป
    await this.Get(this.state.page, this.state.applied);
    alert("", "success", t("success"), t("delete_done"));
  };

  /* ------------------------------------------------------ เปิดกล่องรายละเอียด */
  /* รายละเอียดขอเป็นรายใบ เพราะไทม์ไลน์กับทรัพย์ที่สนใจไม่ได้ติดมากับลิสต์ */
  OpenView = async (item) => {
    this.setState({ modal_view: true, view_item: null, note_text: "" });

    loading(true);
    const result = await GET("admin/customers/" + item.uid, null);
    loading(false);

    if (!result?.status) return this.setState({ modal_view: false });

    this.setState({ view_item: result.data });
  };

  /** โหลดลูกค้าที่เปิดดูอยู่ใหม่ + รีเฟรชตารางให้ตรงกัน (หลังบันทึกอะไรก็ตาม) */
  refreshView = (data) => {
    this.setState({ view_item: data });
    this.Get(this.state.page, this.state.applied);
  };

  /* ----------------------------------------------------------- เปลี่ยนสถานะ */
  ChangeStatus = async (item, status) => {
    if (!item || item.status === status) return;
    const meta = statusMeta(status);
    if (!(await alert("", "info", t("update_status"), `${t("update_status_confirm")}\n${item.name} → ${t(meta.label)}`, t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT("admin/customers/" + item.uid, { status });
    loading(false);

    if (!result?.status) return;

    this.refreshView(result.data);
    alert("", "success", t("success"), t("update_status_done"));
  };

  /* ------------------------------------------------------- มอบหมายผู้ดูแล */
  Assign = async (item, admin_uid) => {
    const admin = this.state.admins.find((e) => e.uid === admin_uid);
    if (!item || !admin || item.admin_uid === admin_uid) return;

    loading(true);
    const result = await PUT("admin/customers/" + item.uid, { admin_uid });
    loading(false);

    if (!result?.status) return;

    this.refreshView(result.data);
    alert("", "success", t("success"), `${t("assign_done")} ${admin.full_name}`);
  };

  /* ------------------------------------------------------------- บันทึกโน้ต */
  AddNote = async () => {
    const item = this.state.view_item;
    const text = this.state.note_text.trim();
    if (!item) return;
    if (!text) return alert("", "warning", t("warning"), t("verify_note_empty"));

    loading(true);
    const result = await POST("admin/customers/" + item.uid + "/activities", { type: "note", detail: text });
    loading(false);

    if (!result?.status) return;

    this.setState({ note_text: "" });
    this.refreshView(result.data);
    alert("", "success", t("success"), t("add_note_done"));
  };

  /* ------------------------------------------------- ลัดไปหน้านัดหมาย / ติดต่อ */
  GoAppointment = (item) => {
    this.setState({ modal_view: false });
    this.props.router.navigate(`/ad/appointments?customer=${item.uid}`);
  };

  /* ถามก่อนโทร — กดพลาดแล้วเครื่องจะโทรออกทันที ย้อนกลับไม่ได้ */
  Call = async (item) => {
    if (!item.phone) return alert("", "warning", t("warning"), t("no_phone_number"));

    const proceed = await alert(
      "",
      "info",
      t("call_customer"),
      `${t("call_customer_confirm")}\n${item.name} · ${fmtPhone(item.phone)}`,
      t("confirm"),
      t("cancel")
    );
    if (!proceed) return;

    window.location.href = `tel:${item.phone}`;
  };

  /* ถามก่อนคัดลอก — การคัดลอกทับสิ่งที่ค้างอยู่ในคลิปบอร์ดของผู้ใช้ */
  CopyContact = async (item) => {
    const proceed = await alert(
      "",
      "info",
      t("copy_contact"),
      `${t("copy_contact_confirm")}\n${item.name} · ${fmtPhone(item.phone)}`,
      t("confirm"),
      t("cancel")
    );
    if (!proceed) return;

    navigator.clipboard?.writeText(`${item.name} · ${fmtPhone(item.phone)} · ${item.email}`);
    alert("", "success", t("success"), t("contact_copied"));
  };

  /* ================================================== render : primitives */
  avatar = (item, size = "") => (
    <div className={`ppl-avatar ${size}`} style={{ background: avatarTone(item.email || item.name) }}>
      {initials(item.name)}
    </div>
  );

  statusBadge = (status) => {
    const meta = statusMeta(status);
    return (
      <span className="crm-badge" style={{ backgroundColor: meta.tint, borderColor: meta.line, color: meta.color }}>
        <span className="icon">{meta.icon}</span>
        {t(meta.label)}
      </span>
    );
  };

  gradeBadge = (grade) => {
    const meta = gradeMeta(grade);
    return (
      <span className="crm-grade" style={{ color: meta.color }}>
        <span className="crm-grade__dots">
          {[1, 2, 3].map((n) => (
            <span key={n} className={`crm-grade__dot ${n <= meta.dots ? "is-on" : ""}`} />
          ))}
        </span>
        {t(meta.label)}
      </span>
    );
  };

  sourceTag = (source) => {
    const meta = sourceMeta(source);
    return (
      <span className="crm-source" style={{ color: meta.color }}>
        <span className="crm-source__icon icon flex-shrink-0" style={{ backgroundColor: meta.tint }}>
          {meta.icon}
        </span>
        <span className="text-truncate">{t(meta.label)}</span>
      </span>
    );
  };

  dueTag = (date) => {
    const info = dueInfo(date);
    if (!info) return <span className="ppl-sub">-</span>;
    return (
      <span className={`crm-due ${info.tone}`}>
        <span className="icon text-10">{""}</span>
        {info.text}
      </span>
    );
  };

  /* ============================================== render : แถบขั้นตอน pipeline */
  /* 4 ขั้นแรกเรียงต่อกันเป็นเส้นทางเดียว ส่วน "ไม่สำเร็จ" วางไว้หลังเส้นคั่น
     เพราะไม่ใช่ขั้นถัดไปของ pipeline แต่เป็นปลายทางอีกทางหนึ่ง */
  renderPipeline = () => {
    const { summary, applied } = this.state;
    const countOf = (value) => summary.status?.[value] || 0;

    /* ตัวเลขที่แถบขั้นตอนบอกไม่ได้ วางเป็นการ์ดเล็กชิดขวาบนหัวการ์ดเดียวกัน
       กว้างเท่าที่เนื้อหาต้องการ ไม่ยืดเต็มแถว — เป็นข้อมูลประกอบ ไม่ใช่พระเอกของการ์ด

       แยก "เลยกำหนด" กับ "วันนี้" เป็นคนละช่อง ไม่รวมเป็น "ต้องติดตามด่วน" ก้อนเดียว
       เพราะพอรวมแล้วต้องมีวงเล็บขยายต่อท้ายว่าแยกเป็นอะไรบ้าง กลายเป็นประโยคยาว
       อ่านไม่ออกว่าเลขไหนคู่กับคำไหน แยกออกมาแล้วทุกช่องเป็นรูปเดียวกัน คือหัวข้อ + เลข

       เลขขึ้นสีเฉพาะตอนที่มันเรียกร้องให้ทำอะไร — เลยกำหนดมีค้างถึงเป็นสีแดง
       ปิดดีลได้แล้วถึงเป็นสีเขียว ถ้าเป็นศูนย์ปล่อยเป็นสีหมึกปกติ จะได้ไม่มีสีมาดึงตาทั้งแถว */
    const tallies = [
      { label: "all_leads", value: num(summary.total), unit: t("unit_people"), tone: "is-brand" },
      { label: "due_overdue", value: num(summary.overdue), tone: summary.overdue ? "is-alert" : "is-muted" },
      { label: "today", value: num(summary.today), tone: summary.today ? "is-warn" : "is-muted" },
      { label: "win_rate", value: `${summary.win_rate}%`, tone: summary.win_rate ? "is-good" : "is-muted" },
    ];
    const lost = statusMeta("lost");
    // เทียบความยาวแถบกับสถานะที่มีลูกค้ามากที่สุด (รวม "ไม่สำเร็จ" ด้วย)
    const max = Math.max(1, ...LEAD_STATUSES.map((meta) => countOf(meta.value)));

    const stage = (meta, isEnd = false) => {
      const active = applied.status === meta.value;
      const count = countOf(meta.value);
      return (
        <button
          key={meta.value}
          type="button"
          className={`crm-stage ${isEnd ? "crm-stage--end" : ""} ${active ? "is-active" : ""}`}
          style={active ? { background: meta.tint } : undefined}
          onClick={() => this.toggleStage(meta.value)}
        >
          <div className="crm-stage__top">
            <span className="crm-stage__icon icon" style={{ backgroundColor: meta.tint, color: meta.color }}>
              {meta.icon}
            </span>
            <span className="crm-stage__label">{t(meta.label)}</span>
          </div>
          <div>
            <span className="crm-stage__value">{num(count)}</span>
            <span className="crm-stage__unit">{t("unit_people")}</span>
          </div>
          <div className="crm-stage__track">
            <div
              className="crm-stage__fill"
              style={{ width: `${Math.round((count / max) * 100)}%`, backgroundColor: meta.color, minWidth: count ? "6px" : 0 }}
            />
          </div>
        </button>
      );
    };

    return (
      <div className="prop-card prop-in mb-3">
        {/* หัวการ์ดสองฝั่ง : ซ้ายเป็นชื่อการ์ดกับคำใบ้ว่ากดขั้นตอนเพื่อกรองได้
            (คำใบ้ต้องอยู่ใต้ชื่อการ์ด ไม่ใช่ลอยอยู่อีกฝั่ง — มันคือคำอธิบายของการ์ดนี้)
            ขวาเป็นตัวเลขสรุปที่แถบขั้นตอนบอกไม่ได้ ย่อเป็นการ์ดเล็กเกาะมุม ไม่กินพื้นที่ทั้งแถว */}
        <div className="prop-card__head py-3">
          <div className="min-w-0">
            <span className="prop-title text-14">
              <span className="prop-title__dot" />
              {t("follow_up_pipeline")}
            </span>
            <div className="crm-pipeline__hint">
              {applied.status ? (
                <button type="button" className="prop-link" onClick={() => this.toggleStage(applied.status)}>
                  <span className="icon text-12">{""}</span>
                  {t("show_all_status")}
                </button>
              ) : (
                <span className="text-secondary text-12">{t("pipeline_hint")}</span>
              )}
            </div>
          </div>

          <div className="crm-tally">
            {tallies.map((tally) => (
              <div key={tally.label} className={`crm-tally__item ${tally.tone}`}>
                <div className="crm-tally__label">
                  <span className="crm-tally__dot" aria-hidden="true" />
                  {t(tally.label)}
                </div>
                <div className="crm-tally__value">
                  {tally.value}
                  {!!tally.unit && <span className="crm-tally__unit">{tally.unit}</span>}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="crm-pipeline">
          {PIPELINE.map((meta, i) => stage(meta, i === PIPELINE.length - 1))}
          <span className="crm-pipeline__sep" aria-hidden="true" />
          {stage(lost, true)}
        </div>
      </div>
    );
  };

  /* ==================================================== render : ตัวกรอง */
  renderFilter = () => {
    const { filter } = this.state;

    const select = (key, options, placeholder = "all") => (
      <Select
        className="prop-field prop-select"
        default={false}
        placeholder={t(placeholder)}
        value={filter[key]}
        options={[{ value: "", label: t("all") }, ...options]}
        onChange={(value) => this.setFilter({ [key]: value })}
      />
    );

    return (
      <div className="prop-card prop-in mb-3">
        <div className="prop-card__head py-3">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            <span className="icon me-1 text-12">{""}</span>
            {t("search_filters")}
          </span>
          <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.clearFilters}>
            <span className="icon text-12">{""}</span>
            {t("clear_filters")}
          </button>
        </div>

        <div className="p-4">
          <div className="row g-3">
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("search_customer")}</label>
              <div className="position-relative">
                <span className="icon prop-field-icon">{""}</span>
                <input
                  type="text"
                  className="prop-field prop-field--icon"
                  placeholder={t("search_customer_placeholder")}
                  value={filter.keyword}
                  onChange={(e) => this.setFilter({ keyword: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                />
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("deal_type")}</label>
              <div className="prop-seg">
                {DEALS.map((d) => {
                  const on = (filter.deals || []).includes(d.value);
                  return (
                    <button
                      key={d.value}
                      type="button"
                      aria-pressed={on}
                      className={`prop-seg__btn ${on ? "is-active" : "bg-white"}`}
                      onClick={() =>
                        this.setFilter({
                          deals: on
                            ? (filter.deals || []).filter((e) => e !== d.value)
                            : [...(filter.deals || []), d.value],
                        })
                      }
                    >
                      {t(d.label)}
                    </button>
                  );
                })}
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("lead_status")}</label>
              {select("status", LEAD_STATUSES.map((s) => ({ value: s.value, label: t(s.label) })))}
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("lead_source")}</label>
              {select("source", LEAD_SOURCES.map((s) => ({ value: s.value, label: t(s.label) })))}
            </div>

            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("property_type")}</label>
              {select("category", this.categoryOptions())}
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("lead_grade")}</label>
              {select("grade", LEAD_GRADES.map((g) => ({ value: g.value, label: t(g.label) })))}
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("owner_admin")}</label>
              {select("admin", this.adminOptions())}
            </div>
            <div className="col-xl-3 col-md-6">
              <label className="prop-label">{t("follow_up_due")}</label>
              {select("due", DUE_OPTIONS.map((d) => ({ value: d.value, label: t(d.label) })))}
            </div>

            {/* prop-datefield ยกปฏิทินให้ลอยเหนือฟิลด์อื่นในแถวเดียวกัน */}
            <div className="col-xl-3 col-md-6 prop-datefield">
              <label className="prop-label">{t("contact_date")}</label>
              <DateRangePicker
                type="th"
                className="prop-field"
                value={filter.created}
                onChange={(value) => this.setFilter({ created: value })}
              />
            </div>

            {/* ปุ่มค้นหาแชร์บรรทัดเดียวกับช่องวันที่ — ชิดขวาสุดของแถว */}
            <div className="col-xl-9 col-md-6 d-flex align-items-end justify-content-end">
              <button type="button" className="prop-btn" onClick={() => this.Get(1)}>
                <span className="icon text-14">{""}</span>
                {t("search")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* ================================================= render : แถบผลการค้นหา */
  renderToolbar = () => {
    const { count, sort, view } = this.state;
    return (
      <div className="prop-card prop-in p-3 mb-3">
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
          <div>
            <span className="fw-bold text-dark">{t("search_results")}</span>
            <span className="fw-bold ms-2" style={{ color: "#4d7c0f" }}>{num(count)}</span>
            <span className="text-secondary text-12 ms-1">{t("unit_people")}</span>
          </div>

          <div className="d-flex flex-wrap align-items-center gap-2">
            <span className="text-secondary text-12">{t("sort_by")}</span>
            <Select
              className="prop-field prop-select wpx-220"
              default={false}
              placeholder={t("sort_by")}
              value={sort}
              options={SORTS.map((s) => ({ value: s.value, label: t(s.label) }))}
              onChange={(value) => value && this.Get(1, this.state.applied, value)}
            />
            <div className="prop-toggle">
              <button
                type="button"
                title={t("list_view")}
                className={`prop-toggle__btn icon ${view === "table" ? "is-active" : ""}`}
                onClick={() => this.switchView("table")}
              >
                {""}
              </button>
              <button
                type="button"
                title={t("board_view")}
                className={`prop-toggle__btn icon ${view === "board" ? "is-active" : ""}`}
                onClick={() => this.switchView("board")}
              >
                {""}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* ================================================= render : เมนูจัดการรายแถว */
  /* รวมทุกคำสั่งไว้ในเมนู "..." เมนูเดียว (แบบเดียวกับหน้าผู้ใช้/ทรัพย์) ช่องจัดการ
     จะได้ไม่กินความกว้างตาราง และแถวเตี้ย ๆ ก็ไม่มีปุ่มเบียดกันจนกดผิด

     index/total ใช้เลือกทิศทางที่เมนูกาง : แถวท้าย ๆ กางขึ้นบน จะได้ไม่ทะลุพ้นจอ
     (ต้องมีแถวอยู่เหนือพอสมควรด้วย ตารางสั้น ๆ จึงกางลงตามปกติ)

     ยกตัวยึดเมนูขึ้นเหนือฉากคลุม (1040) ทั้งก้อน เพื่อไม่ต้องหวังว่า z-index ของ
     .prop-pop จะไปเทียบกับฉากคลุมในชั้นเดียวกันเสมอ — และยังต่ำกว่า sweetalert2 (1060)
     กล่องยืนยันที่เด้งตามมาจึงยังทับเมนูได้ตามปกติ */
  renderActions = (item, index, total) => {
    const open = this.state.menu_open === item.uid;
    const up = index >= 3 && index >= total - 3;

    return (
      <div className="d-flex justify-content-center">
        <div className="position-relative" style={open ? { zIndex: 1051 } : undefined}>
          <button
            type="button"
            className={`prop-iconbtn icon ${open ? "prop-iconbtn--dark" : ""}`}
            title={t("more_options")}
            aria-expanded={open}
            onClick={() => this.setState({ menu_open: open ? "" : item.uid })}
          >
            {"\uf141"}
          </button>

          {open && (
            <>
              {/* ฉากคลุมทั้งจอ — คลิกที่ไหนก็ปิดเมนู */}
              <div className="position-fixed" style={{ inset: 0, zIndex: 1040 }} onClick={() => this.setState({ menu_open: "" })} />
              <div className="prop-pop" style={up ? { top: "auto", bottom: "calc(100% + 8px)" } : undefined}>
                <button type="button" className="prop-pop__item" onClick={() => this.RowAction(item, this.OpenView)}>
                  <span className="icon">{"\uf06e"}</span>
                  {t("view_details")}
                </button>
                {can("customers.update") && (
                  <button type="button" className="prop-pop__item" onClick={() => this.RowAction(item, this.OpenEdit)}>
                    <span className="icon">{"\uf044"}</span>
                    {t("edit")}
                  </button>
                )}
                <div className="prop-pop__sep" />
                <button type="button" className="prop-pop__item" onClick={() => this.RowAction(item, this.GoAppointment)}>
                  <span className="icon">{"\uf274"}</span>
                  {t("create_appointment")}
                </button>
                <button type="button" className="prop-pop__item" onClick={() => this.RowAction(item, this.Call)}>
                  <span className="icon">{"\uf095"}</span>
                  {t("call_customer")}
                </button>
                <button type="button" className="prop-pop__item" onClick={() => this.RowAction(item, this.CopyContact)}>
                  <span className="icon">{"\uf0c5"}</span>
                  {t("copy_contact")}
                </button>
                {can("customers.delete") && (
                  <>
                    <div className="prop-pop__sep" />
                    <button type="button" className="prop-pop__item is-danger" onClick={() => this.RowAction(item, this.Delete)}>
                      <span className="icon">{"\uf2ed"}</span>
                      {t("delete")}
                    </button>
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  /* ===================================================== render : ตารางลูกค้า */
  renderTable = () => {
    const { data, menu_open } = this.state;

    /* table-responsive = overflow-x: auto ซึ่งเบราว์เซอร์บังคับให้ overflow-y เป็น auto
       ตามไปด้วย กล่องนี้จึงตัดขอบทุกอย่างที่ล้นออกนอกตาราง รวมถึงเมนู "..." ที่กางอยู่
       (ยิ่งมีลูกค้าไม่กี่แถว ตารางยิ่งเตี้ย เมนูโดนตัดหายทั้งอัน)
       ตอนมีเมนูกางจึงเปิด overflow ทิ้งไว้ก่อน — มุมล่างของตารางไม่ได้พึ่ง overflow แล้ว
       เพราะย้ายไปโค้งที่แถวสุดท้ายใน people.css แทน */
    return (
      <div className="prop-card prop-in">
        <div
          className="table-responsive"
          style={{ borderRadius: "18px", overflow: menu_open ? "visible" : undefined }}
        >
          {/* ไม่กำหนดความกว้างคอลัมน์ไว้เลย ปล่อยให้ table-layout: auto วัดจากข้อมูลจริง
              คอลัมน์ไหนข้อมูลสั้นก็แคบตามไปเอง ไม่มีช่องว่างค้างอยู่ท้ายช่อง
              ตารางกว้างเกินการ์ดเมื่อไรก็เลื่อนดูทางขวาได้ ดีกว่าบีบทุกคอลัมน์ให้ลงจอ
              แล้วเหลือแต่ ... ทั้งแถว

              min-width ของแต่ละช่องกันไม่ให้คอลัมน์แคบจนหัวข้อตกบรรทัด
              ส่วน max-width ของข้อความอิสระ (ชื่อลูกค้า ชื่อทรัพย์ โซน) กันอีกทาง
              ไม่ให้ค่าที่ยาวผิดปกติแถวเดียวลากตารางยาวออกไปเป็นพันพิกเซล */}
          <table className={`ppl-table crm-table ${menu_open ? "is-menu-open" : ""}`}>
            <thead>
              <tr>
                <th>{t("customer_col")}</th>
                <th>{t("contact")}</th>
                <th>{t("requirement")}</th>
                <th>{t("interested_property")}</th>
                <th>{t("owner_admin")}</th>
                <th>{t("lead_status")}</th>
                <th className="text-center">{t("actions")}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => {
                const first = item.interested?.[0];
                const more = (item.interested?.length || 0) - 1;

                return (
                  <tr key={item.uid} className={menu_open === item.uid ? "is-menu-open" : ""}>
                    {/* ลูกค้า — คอลัมน์เดียวในตารางที่เป็น 3 บรรทัด (คอลัมน์อื่น 2 บรรทัด)
                        ระดับความสนใจอยู่บรรทัดล่างสุดของตัวเอง ไม่ต่อท้ายชื่อ เพราะถ้าไปต่อท้าย
                        ตำแหน่งจะขยับตามความยาวชื่อของแต่ละคน กวาดตาลงมาทั้งคอลัมน์แล้วไม่ตรงกันสักแถว
                        อยู่บรรทัดของตัวเองจึงเรียงเป็นแนวเดียว เทียบว่าใครร้อนใครเย็นได้ในตาเดียว
                        แถวจะสูงตามคอลัมน์นี้ ส่วนคอลัมน์อื่นชิดบนให้บรรทัดแรกตรงกันหมด */}
                    <td>
                      <div className="d-flex align-items-center gap-3">
                        <div className="flex-shrink-0">{this.avatar(item)}</div>
                        <div className="min-w-0 flex-grow-1">
                          <div className="crm-lead__name text-truncate pointer" style={{ maxWidth: "220px" }} onClick={() => this.OpenView(item)}>
                            {dash(item.name)}
                          </div>
                          <div className="ppl-sub text-truncate mt-1" style={{ maxWidth: "220px" }}>
                            {[item.code, item.nickname].filter(Boolean).join(" · ") || "-"}
                          </div>
                          <div className="">{this.gradeBadge(item.grade)}</div>
                        </div>
                      </div>
                    </td>

                    {/* ติดต่อ — เบอร์กับช่องทางที่ทักเข้ามา สองอย่างนี้ใช้ตอนตัดสินใจว่าจะติดต่อกลับยังไง
                        อีเมลอยู่ในกล่องรายละเอียดและปุ่ม "คัดลอกข้อมูลติดต่อ" อย่างเดียว */}
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <span className="icon text-secondary text-12 flex-shrink-0">{"\uf095"}</span>
                        <span className="text-truncate min-w-0">{fmtPhone(item.phone)}</span>
                      </div>
                      <div className="d-flex mt-1 min-w-0">{this.sourceTag(item.source)}</div>
                    </td>

                    {/* ความต้องการ — บรรทัดบนคือ "อยากได้อะไร" บรรทัดล่างคือ "แค่ไหน ที่ไหน"
                        ป้ายไม่ตัดขึ้นบรรทัดใหม่ ประเภททรัพย์ชื่อยาวให้ตัดเป็น ... แทน */}
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <span className="ppl-pill ppl-pill--role flex-shrink-0">
                          {dash(t(DEALS.find((d) => d.value === item.deal)?.label))}
                        </span>
                        <span className="ppl-pill ppl-pill--ghost min-w-0">
                          <span className="text-truncate" style={{ maxWidth: "140px" }}>{categoryName(item.asset_category)}</span>
                        </span>
                      </div>
                      <div className="d-flex align-items-baseline gap-2 mt-1">
                        <span className="crm-lead__budget flex-shrink-0">
                          {budgetText(item)}
                          {hasBudget(item) && <span className="ppl-sub fw-normal"> {t("unit_baht")}</span>}
                        </span>
                        {/* <span className="ppl-sub text-truncate min-w-0" style={{ maxWidth: "120px" }}>{dash(item.zone)}</span> */}
                      </div>
                    </td>

                    {/* ทรัพย์ที่สนใจ */}
                    <td>
                      {first ? (
                        <>
                          <div className="d-flex align-items-center gap-2">
                            <span className="icon text-secondary text-12 flex-shrink-0">{"\uf1ad"}</span>
                            <span className="text-truncate min-w-0" style={{ maxWidth: "180px" }}>{dash(first.title)}</span>
                          </div>
                          <div className="ppl-sub text-truncate mt-1" style={{ maxWidth: "180px" }}>
                            {dash(first.code)}
                            {more > 0 ? ` · +${more} ${t("unit_items")}` : ""}
                          </div>
                        </>
                      ) : (
                        <span className="ppl-sub">-</span>
                      )}
                    </td>

                    {/* ผู้ดูแล */}
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <span className="icon text-secondary text-12 flex-shrink-0">{"\uf007"}</span>
                        <span className="text-truncate min-w-0" style={{ maxWidth: "150px" }}>{item.admin_name || "-"}</span>
                      </div>
                      <div className="ppl-sub text-truncate mt-1">
                        {t("contact_count")} {num(item.contact_count)} {t("unit_times")}
                      </div>
                    </td>

                    {/* สถานะ + วันติดตาม */}
                    <td>
                      {this.statusBadge(item.status)}
                      <div className="mt-1">{this.dueTag(item.next_follow_at)}</div>
                    </td>

                    {/* จัดการ — รวมทุกคำสั่งไว้ในเมนู "..." เมนูเดียว */}
                    <td>{this.renderActions(item, index, data.length)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  /* ================================================== render : บอร์ดตามสถานะ */
  /* บอร์ดแสดง "ผลลัพธ์ทั้งหมดของตัวกรอง" ไม่ตัดหน้า เพราะแต่ละคอลัมน์ต้องเห็นครบ */
  renderBoard = () => {
    const { board, applied } = this.state;
    // ถ้ากรองสถานะไว้อยู่แล้วให้แสดงเฉพาะคอลัมน์นั้น จะได้ไม่มีคอลัมน์ว่างเรียงยาว
    const columns = applied.status ? LEAD_STATUSES.filter((s) => s.value === applied.status) : LEAD_STATUSES;

    return (
      <div className="crm-board prop-in">
        {columns.map((stage) => {
          const items = board.filter((e) => e.status === stage.value);
          return (
            <div className="crm-col" key={stage.value}>
              <div className="crm-col__head">
                <span className="crm-stage__icon icon" style={{ backgroundColor: stage.tint, color: stage.color }}>
                  {stage.icon}
                </span>
                <span className="crm-col__name">{t(stage.label)}</span>
                <span className="crm-col__count" style={{ backgroundColor: stage.tint, color: stage.color }}>
                  {num(items.length)}
                </span>
              </div>
              <div className="crm-col__body">
                {items.map((item) => {
                  const first = item.interested?.[0];
                  const grade = gradeMeta(item.grade);
                  return (
                    <div key={item.uid} className="crm-card" onClick={() => this.OpenView(item)}>
                      <span className="crm-card__strip" style={{ backgroundColor: grade.color }} />
                      <div className="d-flex align-items-center gap-2">
                        {this.avatar(item, "ppl-avatar--sm")}
                        <div className="min-w-0 flex-grow-1">
                          <div className="crm-card__name">{item.name}</div>
                          <div className="crm-card__meta">
                            <span>{item.code}</span>
                            <span>·</span>
                            <span className="text-truncate">{categoryName(item.asset_category)}</span>
                          </div>
                        </div>
                      </div>

                      {!!first && (
                        <div className="crm-card__prop">
                          <span className="icon text-10">{""}</span>
                          <span className="text-truncate">{first.title}</span>
                        </div>
                      )}

                      <div className="crm-card__foot">
                        <span className="crm-lead__budget">{budgetText(item)}</span>
                        {this.dueTag(item.next_follow_at)}
                      </div>
                    </div>
                  );
                })}
                {!items.length && <div className="crm-col__empty">{t("no_leads_in_stage")}</div>}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  /* ===================================================== render : ผลลัพธ์ */
  renderResults = () => {
    const { count, page, view } = this.state;

    if (!count) {
      return (
        <div className="prop-card prop-in">
          <div className="prop-empty">
            <div className="prop-empty__icon icon">{""}</div>
            <div className="fw-bold text-dark mb-1">{t("no_customers_found")}</div>
            <div className="text-12">{t("try_adjust_filters")}</div>
            <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm mt-3" onClick={this.clearFilters}>
              <span className="icon text-12">{""}</span>
              {t("clear_all")}
            </button>
          </div>
        </div>
      );
    }

    if (view === "board") return this.renderBoard();

    const from = (page - 1) * PAGE_SIZE + 1;
    const to = Math.min(page * PAGE_SIZE, count);

    return (
      <>
        {this.renderTable()}
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-4 text-secondary text-12">
          <div>
            {t("showing")} {from}-{to} {t("of")} {num(count)} {t("unit_people")}
          </div>
          <Pagination
            className="mb-0"
            page={page}
            count={Math.ceil(count / PAGE_SIZE) || 1}
            showFirstButton={false}
            showLastButton={false}
            onChange={(_, next) => {
              this.Get(next, this.state.applied);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          />
        </div>
      </>
    );
  };

  /* ============================================== render : ฟอร์มเพิ่มลูกค้า */
  renderFormModal = () => {
    const { modal_form, form, property_keyword, edit_uid } = this.state;
    const choices = this.propertyChoices();
    // ผู้ใช้ภายในได้ null — ช่องผู้ดูแลเป็น dropdown ตามปกติ
    const self = partnerSelf();

    /* หัวข้อย่อยในฟอร์ม — คั่นให้อ่านง่ายเวลากรอกยาว ๆ */
    const section = (icon, title, hint) => (
      <div className="col-12">
        <div className="d-flex align-items-center gap-2 pt-2">
          <span className="icon text-12" style={{ color: "#4d7c0f" }}>{icon}</span>
          <span className="fw-bold text-dark text-14">{title}</span>
          {!!hint && <span className="text-secondary text-12">· {hint}</span>}
        </div>
        <div className="mt-2" style={{ height: "1px", backgroundColor: "#e6ece1" }} />
      </div>
    );

    return (
      <Modal
        size="lg"
        show={modal_form}
        onHide={this.CloseCreate}
        centered
        scrollable
        contentClassName="border-0 rounded-4 overflow-visible shadow-lg"
      >
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
          <div>
            <h5 className="fw-bold mb-0 text-dark">{edit_uid ? t("edit_customer") : t("add_customer")}</h5>
            <div className="text-secondary text-12">{edit_uid ? t("customer_edit_desc") : t("customer_form_desc")}</div>
          </div>
        </Modal.Header>

        <Modal.Body className="p-4 bg-white">
          <div className="row g-3">
            {/* ---------------------------------------------- ข้อมูลติดต่อ */}
            {section("", t("contact_information"), t("customer_contact_hint"))}

            <div className="col-md-6">
              <label className="prop-label">
                {t("customer_name")} <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("customer_name_placeholder")}
                value={form.name}
                onChange={(e) => this.setForm({ name: e.target.value })}
              />
            </div>
            <div className="col-md-6">
              <label className="prop-label">
                {t("nickname")} <span className="text-secondary fw-normal">({t("optional")})</span>
              </label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("customer_nickname_placeholder")}
                value={form.nickname}
                onChange={(e) => this.setForm({ nickname: e.target.value })}
              />
            </div>

            <div className="col-md-6">
              <label className="prop-label">
                {t("phone")} <span className="text-danger">*</span>
              </label>
              <input
                type="tel"
                inputMode="tel"
                maxLength={10}
                className="prop-field"
                placeholder={t("phone_placeholder")}
                value={form.phone}
                // รับเฉพาะตัวเลข — เบอร์ที่มีขีดหรือเว้นวรรคทำให้เช็กเบอร์ซ้ำพลาด
                onChange={(e) => this.setForm({ phone: e.target.value.replace(/[^0-9]/g, "") })}
              />
            </div>
            <div className="col-md-6">
              <label className="prop-label">
                {t("email")} <span className="text-secondary fw-normal">({t("optional")})</span>
              </label>
              <input
                type="email"
                className="prop-field"
                placeholder={t("email_placeholder")}
                value={form.email}
                onChange={(e) => this.setForm({ email: e.target.value })}
              />
            </div>

            <div className="col-md-6">
              <label className="prop-label">
                {t("lead_source")} <span className="text-danger">*</span>
              </label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("lead_source")}
                value={form.source}
                options={LEAD_SOURCES.map((s) => ({ value: s.value, label: t(s.label) }))}
                onChange={(value) => value && this.setForm({ source: value })}
              />
            </div>
            <div className="col-md-6">
              <label className="prop-label">{t("lead_grade")}</label>
              <div className="prop-seg">
                {LEAD_GRADES.map((g) => (
                  <button
                    key={g.value}
                    type="button"
                    aria-pressed={form.grade === g.value}
                    className={`prop-seg__btn ${form.grade === g.value ? "is-active" : ""}`}
                    onClick={() => this.setForm({ grade: g.value })}
                  >
                    {t(g.label)}
                  </button>
                ))}
              </div>
            </div>

            {/* ---------------------------------------------- ความต้องการ */}
            {section("", t("requirement"), t("customer_requirement_hint"))}

            <div className="col-md-6">
              <label className="prop-label">
                {t("deal_type")} <span className="text-danger">*</span>
              </label>
              <div className="prop-seg">
                {DEALS.map((d) => (
                  <button
                    key={d.value}
                    type="button"
                    aria-pressed={form.deal === d.value}
                    className={`prop-seg__btn ${form.deal === d.value ? "is-active" : ""}`}
                    onClick={() => this.setForm({ deal: d.value })}
                  >
                    {t(d.label)}
                  </button>
                ))}
              </div>
            </div>
            <div className="col-md-6">
              <label className="prop-label">
                {t("property_type")} <span className="text-danger">*</span>
              </label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("property_type")}
                value={form.asset_category_uid}
                options={this.categoryOptions()}
                onChange={(value) => value && this.setForm({ asset_category_uid: value })}
              />
            </div>

            <div className="col-md-6">
              <label className="prop-label">{t("zone_district")}</label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("zone_placeholder")}
                value={form.zone}
                onChange={(e) => this.setForm({ zone: e.target.value })}
              />
            </div>
            <div className="col-md-6">
              <label className="prop-label">
                {t("budget")} <span className="text-secondary fw-normal">({t("unit_baht")})</span>
              </label>
              <div className="prop-minmax">
                <input
                  type="number"
                  min="0"
                  className="prop-field"
                  placeholder={t("budget_min")}
                  value={form.budget_min}
                  onChange={(e) => this.setForm({ budget_min: e.target.value })}
                />
                <span className="prop-minmax__sep">-</span>
                <input
                  type="number"
                  min="0"
                  className="prop-field"
                  placeholder={t("budget_max")}
                  value={form.budget_max}
                  onChange={(e) => this.setForm({ budget_max: e.target.value })}
                />
              </div>
            </div>

            {/* prop-datefield ยกปฏิทินให้ลอยเหนือฟิลด์อื่นในแถวเดียวกัน */}
            <div className="col-md-6 prop-datefield">
              <label className="prop-label">{t("move_in_date")}</label>
              <DatePicker
                type="th"
                className="prop-field"
                value={form.move_in_at}
                onChange={(value) => this.setForm({ move_in_at: value ? new Date(value) : null })}
              />
            </div>
            <div className="col-md-6">
              <label className="prop-label">{t("customer_note")}</label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("customer_note_placeholder")}
                value={form.note}
                onChange={(e) => this.setForm({ note: e.target.value })}
              />
            </div>

            {/* ------------------------------------------- ทรัพย์ที่สนใจ */}
            {section("", t("interested_property"), t("interested_property_hint"))}

            <div className="col-12">
              <div className="position-relative mb-2">
                <span className="icon prop-field-icon">{""}</span>
                <input
                  type="text"
                  className="prop-field prop-field--icon"
                  placeholder={t("search_property_placeholder")}
                  value={property_keyword}
                  onChange={(e) => this.setState({ property_keyword: e.target.value })}
                />
              </div>

              {/* เลือกได้หลายรายการ — ใช้ตารางหน้าตาเดียวกับคิวงานโพสต์ เพื่อให้อ่านข้อมูล
                  ทรัพย์ด้วยสายตาชุดเดิม : รหัส / ชื่อ-ทำเล / ค่าเช่า / สถานะ
                  รายการที่ตรงประเภทที่ลูกค้าต้องการถูกดันขึ้นบนสุด */}
              <div className="crm-pick">
                <table className="mk-table">
                  <thead>
                    <tr>
                      <th className="mk-c-check" />
                      <th className="mk-c-code">{t("mk_col_code")}</th>
                      <th>{t("mk_col_asset")}</th>
                      <th className="mk-c-rent">{t("rent_price")}</th>
                      <th className="mk-c-status">{t("status")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {choices.map((property) => {
                      const on = form.asset_uids.includes(property.uid);
                      const status = assetStatusMeta(property.status);
                      // ไอคอน/สี/ชื่อประเภท มาจาก master ที่ API ส่งมากับทรัพย์
                      const grad = property.asset_category?.grad || "";
                      const icon = property.asset_category?.icon || "";
                      const type_label = categoryName(property.asset_category);

                      return (
                        <tr
                          key={property.uid}
                          className={on ? "is-picked" : ""}
                          onClick={() => this.toggleInterested(property.uid)}
                        >
                          <td className="mk-c-check">
                            {/* กันคลิกซ้อนกับ onClick ของแถว ไม่งั้นติ๊กแล้วสลับกลับทันที */}
                            <label className="mk-check" onClick={(e) => e.stopPropagation()}>
                              <input type="checkbox" checked={on} onChange={() => this.toggleInterested(property.uid)} />
                            </label>
                          </td>

                          <td className="mk-c-code">
                            <span className="mk-code">{property.code}</span>
                          </td>

                          <td>
                            <div className="mk-asset">
                              {/* รูปหลักของทรัพย์ — ยังไม่มีรูปจริงจะขึ้นพื้นไล่เฉดตามประเภทแทน */}
                              <div className="mk-thumb" style={{ background: grad }}>
                                {property.image ? (
                                  <img src={property.image} alt={property.title} />
                                ) : (
                                  <span className="mk-thumb__ghost icon">{icon}</span>
                                )}
                              </div>
                              <div className="mk-asset__text">
                                <span className="mk-asset__name text-truncate" title={property.title}>
                                  {property.title}
                                </span>
                                <div className="mk-asset__meta">
                                  <span className="text-truncate" title={property.zone}>{property.zone}</span>
                                  <span className="mk-tag" style={{ background: grad }}>{type_label}</span>
                                </div>
                              </div>
                            </div>
                          </td>

                          <td className="mk-c-rent">
                            <span className="mk-price">{num(property.rent)}</span>
                            <span className="mk-price__unit">{t("baht_per_month")}</span>
                          </td>

                          <td className="mk-c-status">
                            <span className="mk-badge" style={{ backgroundColor: status.tint, color: status.color }}>
                              {t(status.label)}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {!choices.length && <div className="crm-col__empty">{t("no_properties_found")}</div>}
              </div>

              <div className="text-secondary text-12 mt-2">
                {t("selected")} {form.asset_uids.length} {t("unit_items")}
              </div>
            </div>

            {/* ------------------------------------------ การติดตามผล */}
            {section("", t("follow_up_assign"), t("follow_up_assign_hint"))}

            <div className="col-md-4">
              <label className="prop-label">{t("lead_status")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("lead_status")}
                value={form.status}
                options={LEAD_STATUSES.map((s) => ({ value: s.value, label: t(s.label) }))}
                onChange={(value) => value && this.setForm({ status: value })}
              />
            </div>
            <div className="col-md-4">
              <label className="prop-label">
                {t("owner_admin")} <span className="text-danger">*</span>
              </label>
              {/* พาร์ตเนอร์เป็นผู้ดูแลลูกค้าที่ตัวเองหามาเสมอ ช่องนี้จึงเป็นข้อความล็อกไว้
                  ไม่ใช่ dropdown — โยนงานให้ทีมงานคนอื่นเองไม่ได้
                  ชื่อดึงจากรายชื่อผู้ดูแลก่อน (เผื่อลูกค้าเก่าที่คนอื่นดูแลอยู่)
                  ยังโหลดรายชื่อไม่เสร็จค่อยใช้ชื่อในโปรไฟล์ตัวเอง */}
              {self ? (
                <input
                  type="text"
                  className="prop-field"
                  value={this.adminName(form.admin_uid) || self.full_name || ""}
                  disabled
                  readOnly
                />
              ) : (
                <Select
                  className="prop-field prop-select"
                  default={false}
                  placeholder={t("select_agent")}
                  value={form.admin_uid}
                  options={this.adminOptions()}
                  onChange={(value) => value && this.setForm({ admin_uid: value })}
                />
              )}
            </div>
            <div className="col-md-4 prop-datefield">
              <label className="prop-label">{t("next_follow")}</label>
              {/* ปิดงานแล้ว (ปิดดีล/ไม่สำเร็จ) ไม่ต้องกำหนดวันติดตามถัดไป */}
              {isClosedStatus(form.status) ? (
                <input type="text" className="prop-field" value="-" disabled readOnly />
              ) : (
                <DatePicker
                  type="th"
                  className="prop-field"
                  value={form.next_follow_at}
                  onChange={(value) => this.setForm({ next_follow_at: value ? new Date(value) : null })}
                />
              )}
            </div>

            {/* โน้ตแรกมีเฉพาะตอนเพิ่มลูกค้าใหม่ — ของเดิมแก้ผ่านไทม์ไลน์ในหน้ารายละเอียด
                ไม่งั้นกดแก้ไขทีจะกลายเป็นเพิ่มโน้ตซ้ำทุกครั้งที่บันทึก */}
            {!edit_uid && (
              <div className="col-12">
                <label className="prop-label">{t("add_activity_note")}</label>
                <textarea
                  className="crm-textarea"
                  placeholder={t("note_placeholder")}
                  value={form.first_note}
                  onChange={(e) => this.setForm({ first_note: e.target.value })}
                />
              </div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseCreate}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" onClick={this.Save}>
            <span className="icon text-12">{""}</span>
            {t("save")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  /* ========================================== render : กล่องดูรายละเอียดลูกค้า */
  renderViewModal = () => {
    const { modal_view, note_text, view_item: item } = this.state;
    // กำลังโหลดรายละเอียดอยู่ (เพิ่งกดจากตาราง ยังไม่ได้คำตอบจาก API) — ยังไม่ต้องวาด
    if (!item) return null;

    const status = statusMeta(item.status);
    const grade = gradeMeta(item.grade);
    const source = sourceMeta(item.source);

    const kv = (label, value) => (
      <div className="crm-kv">
        <span className="crm-kv__label">{label}</span>
        <span className="crm-kv__value">{dash(value)}</span>
      </div>
    );

    return (
      <Modal
        size="xl"
        show={modal_view}
        onHide={() => this.setState({ modal_view: false })}
        centered
        scrollable
        contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
      >
        <Modal.Body className="p-0 bg-white">
          {/* หัวกล่อง — โทนเข้มตัดกับเนื้อหาด้านล่าง */}
          <div className="crm-hero">
            <div className="d-flex align-items-start gap-3 position-relative" style={{ zIndex: 1 }}>
              {this.avatar(item, "ppl-avatar--lg")}
              <div className="min-w-0 flex-grow-1">
                <h5 className="fw-bold mb-1 text-truncate">{item.name}</h5>
                <div className="crm-hero__sub mb-2">
                  {item.code}
                  {item.nickname ? ` · ${item.nickname}` : ""} · {t("lead_since")} {dateText(item.created_at)}
                </div>
                <div className="d-flex flex-wrap align-items-center gap-2">
                  <span className="crm-badge" style={{ backgroundColor: status.tint, borderColor: status.line, color: status.color }}>
                    <span className="icon">{status.icon}</span>
                    {t(status.label)}
                  </span>
                  <span className="crm-badge" style={{ backgroundColor: "rgba(255,255,255,.12)", borderColor: "rgba(255,255,255,.2)", color: "#fff" }}>
                    <span className="icon">{source.icon}</span>
                    {t(source.label)}
                  </span>
                  <span className="crm-badge" style={{ backgroundColor: grade.tint, borderColor: "transparent", color: grade.color }}>
                    {t(grade.label)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="p-4" style={{ backgroundColor: "#f6f8f3" }}>
            <div className="row g-3">
              {/* ---------- ซ้าย : ข้อมูลลูกค้าและความต้องการ ---------- */}
              <div className="col-lg-5">
                <div className="crm-panel mb-3">
                  <div className="crm-panel__head">
                    <span>
                      <span className="icon me-2 text-10">{""}</span>
                      {t("contact_information")}
                    </span>
                    <button type="button" className="prop-link" onClick={() => this.CopyContact(item)}>
                      <span className="icon text-10">{""}</span>
                      {t("copy")}
                    </button>
                  </div>
                  <div className="crm-panel__body py-2">
                    {kv(t("phone"), fmtPhone(item.phone))}
                    {kv(t("email"), item.email)}
                    {kv(t("lead_source"), t(source.label))}
                    {kv(t("contact_count"), `${num(item.contact_count)} ${t("unit_times")}`)}
                    {kv(t("last_contact"), item.last_contact_at ? dateText(item.last_contact_at) : t("time_never"))}
                    {kv(t("next_follow"), item.next_follow_at ? dateText(item.next_follow_at) : "-")}
                  </div>
                </div>

                <div className="crm-panel mb-3">
                  <div className="crm-panel__head">
                    <span>
                      <span className="icon me-2 text-10">{""}</span>
                      {t("requirement")}
                    </span>
                  </div>
                  <div className="crm-panel__body py-2">
                    {kv(t("deal_type"), t(DEALS.find((d) => d.value === item.deal)?.label))}
                    {kv(t("property_type"), categoryName(item.asset_category))}
                    {kv(t("zone_district"), item.zone)}
                    {kv(t("budget"), hasBudget(item) ? `${budgetText(item)} ${t("unit_baht")}` : "-")}
                    {kv(t("move_in_date"), dateText(item.move_in_at))}
                    <div className="pt-2">
                      <div className="crm-kv__label mb-1">{t("customer_note")}</div>
                      <div className="text-12" style={{ color: "#47524c", lineHeight: 1.6 }}>{dash(item.note)}</div>
                    </div>
                  </div>
                </div>

                <div className="crm-panel">
                  <div className="crm-panel__head">
                    <span>
                      <span className="icon me-2 text-10">{""}</span>
                      {t("interested_property")}
                    </span>
                    <span className="text-secondary fw-normal">
                      {item.interested.length} {t("unit_items")}
                    </span>
                  </div>
                  <div className="crm-panel__body d-flex flex-column gap-2">
                    {item.interested.map((property) => (
                      <div key={property.uid} className="crm-prop">
                        {/* รูปหลักของทรัพย์ — ยังไม่มีรูปจะขึ้นพื้นไล่เฉดตามประเภทแทน */}
                        <span
                          className="crm-prop__icon icon"
                          style={{ background: property.asset_category?.grad, overflow: "hidden", padding: 0 }}
                        >
                          {property.image ? (
                            <img
                              src={property.image}
                              alt={property.title}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          ) : (
                            property.asset_category?.icon
                          )}
                        </span>
                        <div className="min-w-0 flex-grow-1">
                          <div className="crm-prop__title text-truncate">{property.title}</div>
                          <div className="crm-prop__meta text-truncate">
                            {property.code} · {property.zone}
                          </div>
                          <div className="crm-lead__budget mt-1">
                            {item.deal === "rent"
                              ? `${num(property.rent)} ${t("baht_per_month")}`
                              : `${num(property.price)} ${t("unit_baht")}`}
                          </div>
                        </div>
                        <button
                          type="button"
                          className="prop-iconbtn icon"
                          title={t("view_details")}
                          onClick={() => this.props.router.navigate(`/ad/assets/${property.uid}/edit`)}
                        >
                          {""}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* ---------- ขวา : การติดตามผล ---------- */}
              <div className="col-lg-7">
                <div className="crm-panel mb-3">
                  <div className="crm-panel__head">
                    <span>
                      <span className="icon me-2 text-10">{""}</span>
                      {t("update_status")}
                    </span>
                  </div>
                  <div className="crm-panel__body">
                    <div className="crm-steps mb-3">
                      {LEAD_STATUSES.map((meta) => {
                        const active = meta.value === item.status;
                        return (
                          <button
                            key={meta.value}
                            type="button"
                            className={`crm-step ${active ? "is-active" : ""}`}
                            style={active ? { backgroundColor: meta.color } : undefined}
                            onClick={() => this.ChangeStatus(item, meta.value)}
                          >
                            <span className="icon">{meta.icon}</span>
                            {t(meta.label)}
                          </button>
                        );
                      })}
                    </div>

                    <div className="row g-3">
                      <div className="col-md-7">
                        <label className="prop-label">{t("owner_admin")}</label>
                        <Select
                          className="prop-field prop-select"
                          default={false}
                          placeholder={t("select_agent")}
                          value={item.admin_uid}
                          options={this.adminOptions()}
                          onChange={(value) => value && this.Assign(item, value)}
                        />
                      </div>
                      <div className="col-md-5 d-flex align-items-end">
                        <button type="button" className="prop-btn w-100" onClick={() => this.GoAppointment(item)}>
                          <span className="icon text-12">{""}</span>
                          {t("create_appointment")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="crm-panel mb-3">
                  <div className="crm-panel__head">
                    <span>
                      <span className="icon me-2 text-10">{""}</span>
                      {t("add_activity_note")}
                    </span>
                  </div>
                  <div className="crm-panel__body">
                    <textarea
                      className="crm-textarea"
                      placeholder={t("note_placeholder")}
                      value={note_text}
                      onChange={(e) => this.setState({ note_text: e.target.value })}
                    />
                    <div className="d-flex justify-content-end mt-2">
                      <button type="button" className="prop-btn prop-btn--dark prop-btn--sm" onClick={this.AddNote}>
                        <span className="icon text-10">{""}</span>
                        {t("save_note")}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="crm-panel">
                  <div className="crm-panel__head">
                    <span>
                      <span className="icon me-2 text-10">{""}</span>
                      {t("activity_timeline")}
                    </span>
                    <span className="text-secondary fw-normal">
                      {item.timeline.length} {t("unit_items")}
                    </span>
                  </div>
                  <div className="crm-panel__body">
                    <div className="crm-timeline">
                      {item.timeline.map((entry) => {
                        // สีและไอคอนของแต่ละเหตุการณ์ยึดตามสถานะที่เกี่ยวข้อง
                        const meta = statusMeta(entry.meta?.to_status || "");
                        const tone = TIMELINE_TONE[entry.type] || { color: meta.color, icon: meta.icon };
                        return (
                          <div className="crm-tl" key={entry.uid}>
                            <span className="crm-tl__dot icon" style={{ backgroundColor: tone.color, color: "#fff" }}>
                              {tone.icon}
                            </span>
                            <div className="crm-tl__title">{t(`activity_${entry.type}`)}</div>
                            {/* detail = ข้อความที่ผู้ใช้พิมพ์เอง แสดงตรง ๆ ไม่ต้องแปลภาษา
                                ส่วนการเปลี่ยนสถานะไม่มี detail จึงเล่าจาก meta แทน */}
                            <div className="crm-tl__detail">{activityDetail(entry)}</div>
                            <div className="crm-tl__meta">
                              {format_date(entry.happened_at, "dd mmm yyyy hh:mm", locale())}
                              {` · ${entry.by || t("from_system")}`}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-between gap-2">
          <div className="d-flex gap-2">
            {can("customers.update") && (
              <button type="button" className="prop-btn prop-btn--ghost" onClick={() => this.OpenEdit(item)}>
                <span className="icon text-12">{"\uf044"}</span>
                {t("edit")}
              </button>
            )}
            <button type="button" className="prop-btn prop-btn--ghost" onClick={() => this.Call(item)}>
              <span className="icon text-12">{""}</span>
              {t("call_customer")}
            </button>
          </div>
          <button type="button" className="prop-btn prop-btn--ghost" onClick={() => this.setState({ modal_view: false })}>
            {t("close")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          {/* หัวข้อหน้า — ลูกค้าส่วนใหญ่มาจากระบบต้นทาง ปุ่มนี้ไว้คีย์เคสโทรเข้า/walk-in */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("customers")}</h3>
              <div className="text-secondary text-14">{t("customers_subtitle")}</div>
            </div>
            <button type="button" className="prop-btn" onClick={this.OpenCreate}>
              <span className="icon text-14">{""}</span>
              {t("add_customer")}
            </button>
          </div>

          {this.renderPipeline()}
          {this.renderFilter()}
          {this.renderToolbar()}
          {this.renderResults()}
        </div>

        {this.renderFormModal()}
        {this.renderViewModal()}
      </div>
    );
  }
}

export default withRouter(Customers);
